// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import answer css modules
import answerStyles from '../answerModuleStyles.css';

function AnswerListItem({ answer }) {
  return (
    <li>
      <Link to={`/answers/${answer._id}`}> {answer.name}</Link>
    </li>
  )
}

AnswerListItem.propTypes = {
  answer: PropTypes.object.isRequired
}

export default AnswerListItem;



// WEBPACK FOOTER //
// modules/answer/components/AnswerListItem.js.jsx